import * as Backend from 'i18next-http-backend';

export type i18nBackendAjaxOverride = (
  url: string,
  options: Backend.BackendOptions,
  callback: Backend.RequestCallback,
  data: Record<string, unknown> | string,
  cache: boolean
) => void;
